import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import useStore from '@/store';

const Layout = () => import('@/layout/Layout.vue');

export const routes: Array<RouteRecordRaw> = [
  {
    path: '/redirect',
    component: Layout,
    meta: { hidden: true },
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/system/common/redirect/index.vue')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/system/login/Login.vue'),
    meta: { hidden: true },
  },
  {
    path: '/404',
    component: () => import('@/views/system/common/error-page/404.vue'),
    meta: { hidden: true },
  },
  {
    path: '/401',
    component: () => import('@/views/system/common/error-page/401.vue'),
    meta: { hidden: true },
  },

  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        component: () => import('@/views/system/home/Home.vue'),
        name: 'Home',
        meta: { title: '主页', icon: 'el-icon-home-filled', affix: true, hidden: false }
      }
    ]
  },
  {
    path: '/profile',
    component: Layout,
    redirect: '/profile/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/system/profile/Profile.vue'),
        name: 'Profile',
        meta: { title: '个人信息', icon: 'user', noCache: true }
      }
    ]
  },
];

// 创建路由
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: routes,
  // 刷新时，滚动条位置还原
  scrollBehavior: () => ({ left: 0, top: 0 })
});

// 重置路由
export function resetRouter() {
  const { permission } = useStore();
  permission.routes.forEach((route: any) => {
    const name = route.name;
    if (name && router.hasRoute(name)) {
      router.removeRoute(name);
    }
  });
}

export default router
